import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientStatus } from '../_models/generatedModels';
import { UserService } from '../_services/generatedServices';
import { ToasterService } from '../_services/toaster.service';

@Injectable()
export class IsAthleteActiveGuard implements CanActivate
{
  athletesUrl: string = '/athletes';

  constructor(private router: Router, public userService: UserService, private toastr: ToasterService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean>
  {
    let userId = 0;

    if (state.url && state.url.startsWith(this.athletesUrl)) {
      const match = state.url.match(/\/(\d+)(\/|$)/);
      userId = match ? Number(match[1]) : NaN;
    }
    else {
      userId = Number(route.paramMap.get('id'));

      if (userId === 0) {
        const match = state.url.match(/\/(\d+)(\/|$)/);
        userId = match ? Number(match[1]) : NaN;
      }
    }

    if (isNaN(userId)) {
      this.goBackToAthleteList();
    }

    return this.userService.getProfileById(userId).pipe(map(result =>
    {
      let isActive = result.status == ClientStatus.Active;

      if (!isActive)
        this.toastr.warning("Inactive account", "Access denied")

      return isActive;
    }));
  }

  goBackToAthleteList()
  {
    this.router.navigateByUrl(this.athletesUrl);
    return false;
  }
}
